import React from 'react';

import { createStyles, Theme, withStyles, IconButton, TextField, Button, Select, Paper, Tooltip, FormControlLabel, Checkbox, FormControl, RadioGroup, Typography, Radio } from '@material-ui/core';
import { Close, DeleteOutline } from '@material-ui/icons';

import styles from '../../attachments/attachments.module.css';

import paymentStyles from '../paymentReportStyles.module.css';
import commonStyles from '../../common/common.module.css';
import MaterialTable from 'material-table';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { PaymentAuditModel } from '../../../models/PaymentAudit';
import { formatCurrency } from '../../../utils/currencyFormatter';
import { LIST_PAYMENTS_REPORT_TYPE } from '../../../utils/listPaymentsType';
import { getPaymentSourceName } from '../../../utils/additionalServices';
import addIcon from '../../../assets/add.svg';
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from 'moment';

const materialStyles = (theme: Theme) =>
  createStyles({
    wrapper: {
      borderRadius: '15px',
      marginBottom: '30px',
      padding: '20px',
      backgroundColor: 'var(--greybkg)',
    },
    header: {
      fontWeight: 600,
      color: 'var(--primaryblue)',
      fontSize: '16px',
      marginTop: '0',
      marginBottom: '0',
    },
    paper: {
      backgroundColor: 'transparent',
    },
    auditWrapper: {
      '& table': {
        padding: 0,
      },
      '& table tbody tr': {
        boxShadow: 'none',
        backgroundColor: 'green',
      },
    },
    auditSelect : {
      '& select': {
        borderRadius: 'var(--ip-br)',
        fontSize: '13px',
      },
    },
    title: {
      paddingLeft: '0px'
    },
    note: {
      marginBottom: '20px'
    },
    radioGroup: {
      display: 'flex',
      flexDirection: 'row',
      minWidth: '150px',
      justifyContent: 'space-between'
    },
    textField: {
      width: '100%',
    },
    buttonDiv: {
      marginTop: '20px'
    },
    manualEntryBtn: {
      fontSize: '50px',
      transform: 'scale(0.8)'
    },
    amountField: {
      width: '100px',
    }
  });

interface PaymentAuditProps {
  classes: any;
  awbNumber: string;
  payment: PaymentAuditModel;
  handleClose: (type: string) => void;
  handleChange: (event: any, type: string) => void;
  save: (type: string) => void;
  paymentAdjustments: Array<PaymentAuditModel>;
  deleteAdjustment: (id: number) => void;
  changeSettled: () => void;
  auditCheck: boolean;
  amountCollected: number;
  remarks: string;
};

const paymentAudit = (props: PaymentAuditProps) => {
  const { classes } = props;
  let payOptions: any = [];

  payOptions = LIST_PAYMENTS_REPORT_TYPE.map((item: any, index: number) => {
    return (
      <option key={index} value={item.value}>{item.name}</option>
    );
  });

  return (
    <div>
      <div className={ paymentStyles.overlay } onClick={ () => props.handleClose('audit') }></div>
      <div className={ paymentStyles.auditWrapper }>

        <div className={ paymentStyles.attachmentsHeader }>

          <div className={ styles.titleBlk } >
            <div className={ classes.title }>Awb charges audit</div>
            <div className={ styles.attachmentsHeaderText }> {props.awbNumber}</div>
          </div>
          <div className={ [styles.attachmentsButton, paymentStyles.attachmentsButton].join(" ") } onClick={() => props.handleClose('audit')} >
            <IconButton aria-label="Close">
              <Close  />
            </IconButton>
          </div>

        </div>

        <div className={ `${ styles.attachmentsBody }`}>
          <div className={ classes.wrapper } >
          <h3 className={ classes.header } >Post Delivery Adjustments</h3>
            <div className={ paymentStyles.driverInfoWrapperFirstRow }>
              <div className={ `${paymentStyles.textFieldReason} ${commonStyles.inputLabelWrapper}` } >
                <label className={ commonStyles.inputLabel }>Reason</label>
                <TextField
                  id='reason'
                  value={ props.payment.reason }
                  onChange={ (event) => props.handleChange(event, 'reason') }
                  variant='outlined'
                  InputProps={{
                    classes: { input: classes.input }
                  }}
                  InputLabelProps={{
                    className: classes.blue
                  }}
                />
              </div>
              <div className={ `${paymentStyles.textFieldAmount } ${ commonStyles.inputLabelWrapper }`} >
                <label className={ commonStyles.inputLabel }>Amount</label>
                <TextField
                  id='amount'
                  value={ props.payment.amount }
                  onChange={ (event) => props.handleChange(event, 'amount') }
                  variant='outlined'
                  type='number'
                  InputProps={{
                    classes: { input: classes.input }
                  }}
                  InputLabelProps={{
                    className: classes.blue
                  }}
                />
              </div>
              <div className={`${ paymentStyles.textFieldDriver } ${ commonStyles.inputLabelWrapper }`} >
                <label className={ commonStyles.inputLabel }>Payment Source</label>
                <Select
                  native
                  value={ props.payment.source }
                  onChange={ (event: any) => props.handleChange(event, 'source') }
                  inputProps={{
                    name: 'company',
                    id: 'company',
                    className: classes.styleInputProps
                  }}
                  className={ classes.auditSelect }
                  variant="outlined"
                >
                  <option value={0} />
                  { payOptions }
                </Select>
              </div>
              <div className={`${paymentStyles.textFieldDriver} ${commonStyles.inputLabelWrapper}`} >
                <label className={commonStyles.inputLabel}>Transaction Date</label>
                <KeyboardDatePicker
                  value={props.payment.pay_date_set}
                  onChange={(event: any) => props.handleChange(event, 'pay_date_set')}
                  inputProps={{
                    name: 'company',
                    id: 'company',
                    className: classes.styleInputProps
                  }}
                  className={classes.auditSelect}
                  inputVariant="outlined"
                  name='pay_date_set'
                  autoOk
                />
              </div>
              <div className={ paymentStyles.fs0 }>
                <Tooltip title="Add">
                  <img alt="logo" src={ addIcon } onClick={ () => props.save('add') } className={ props.classes.manualEntryBtn }/>
                </Tooltip>
              </div>
            </div>
            <div className={ `${ paymentStyles.tableWrapper } ${ paymentStyles.auditTableWrapper }`}>
              <MaterialTable

                components={{ Container: props => <Paper {...props} elevation={0} className={ `${ commonStyles.paperTable }`}/> }}

                columns={[
                  {
                    title: 'Reason', field: 'reason', cellStyle: { minWidth: '35%' }
                  },
                  {
                    title: 'Amount', field: 'amount',cellStyle: { minWidth: 'auto' }, render: (rowData: any) => {
                      return (
                        <div>
                          <div>${formatCurrency(Number(rowData.amount), 2,)}</div>
                        </div>
                      )
                    }
                  },
                  {
                    title: 'Source', field: 'source', render: (rowData: any) => {
                      return (
                        <div>{ getPaymentSourceName(rowData.source) }</div>
                      )
                    }
                  },
                  {
                    title: 'User ID', field: 'username',
                  },
                  {
                    title: 'Adjustment Date', field: 'pay_date', render: (rowData: any) => {
                      return (
                        <div>{ rowData.pay_date ? moment(rowData.pay_date).format('DD-MMM-YY').toUpperCase() : '' }</div>
                      )
                    }
                  },
                  {
                    title: 'Transaction Date', field: 'pay_date_set', render: (rowData: any) => {
                      return (
                        <div>{ rowData.pay_date_set ? moment(rowData.pay_date_set).format('DD-MMM-YY').toUpperCase() : '' }</div>
                      )
                    }
                  },
                  {
                    title: '', headerStyle: { textAlign: 'center' },
                    render: (adjustment: any) => {

                      return <span className={ paymentStyles.awbActionsList } >

                        <Tooltip title="Delete Adjustment">
                          <DeleteOutline onClick={ () => props.deleteAdjustment(adjustment.id) } />
                        </Tooltip>
                      </span>;
                    }
                  }
                ]}

                data={props.paymentAdjustments}

                options={{
                  paging: false,
                  pageSize: 10,
                  headerStyle: {
                    backgroundColor: 'var(--tbl_head_bkg)',
                    color: 'var(--tbl_head_color)',
                    zIndex: 2,
                  },
                  pageSizeOptions: [15, 20],
                  toolbar: false,
                  sorting: false,
                }}
              />
            </div>
          </div>
          <div className={paymentStyles.auditFooter}>
          <div className={ `${paymentStyles.textFieldRemarks} ${commonStyles.inputLabelWrapper}` } >
              <h3 className={ classes.header }>Accounting Remarks</h3>
              <TextField
                id='reason'
                value={ props.remarks }
                onChange={ (event) => props.handleChange(event, 'remarks') }
                variant='outlined'
                InputProps={{
                  classes: { input: classes.input }
                }}
                InputLabelProps={{
                  className: classes.blue
                }}
                className={`${ commonStyles.outlineInput }`}
              />
            </div>
          <div className={ `${paymentStyles.driverInfoWrapperFirstRow } ${commonStyles.fvMiddle }` }>
            <div className={ `${paymentStyles.textFieldAmount } ${paymentStyles.textFieldwrapper }` } >

              <label className={ `${paymentStyles.amountLabel }` }>Total Amount Collected</label>
              <TextField
                id='amount'
                value={ props.amountCollected }
                onChange={ (event) => props.handleChange(event, 'amount_collected') }
                variant='outlined'
                type='number'
                InputProps={{
                  classes: { input: `${ classes.input } ${classes.amountField }` }
                }}
                InputLabelProps={{
                  className: classes.blue
                }}
                className={`${ commonStyles.outlineInput }`}
              />

            </div>
            <FormControlLabel
              value=""
              control={
                <Checkbox
                  name=''
                  icon={<CheckBoxOutlineBlankIcon color="primary" />}
                  checkedIcon={ <CheckBoxIcon color="primary" /> }
                  classes={{
                    root: classes.checkbox,
                  }}
                onChange={ () => props.changeSettled() }
                checked={ props.auditCheck }
                />
              }
              label={'Audit Complete'}
              className={ classes.completeLabel }
            />
            <div className={ [paymentStyles.buttonWrapper].join(" ") }>

              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={ () => props.save('submit') }
                className={ paymentStyles.button }
              >
                Save
              </Button>
            </div>
          </div>
          </div>
      
        </div>

      </div>
    </div>
  );
}

export default withStyles(materialStyles)(paymentAudit);